module.exports = __webpack_public_path__ + "static/media/person-sign.7c504f35.svg";